import { Controller } from "@hotwired/stimulus"

// Syncs per-group A/B config (mode, days, time schedule) into a single hidden JSON field
// so it submits as campaign[ab_config] matching the Next.js ab_config shape.
export default class extends Controller {
  static targets = ["hiddenInput", "groupPanel"]

  connect() {
    this.togglePanels()
    this.sync()
  }

  sync() {
    const config = {
      abModeByGroup: {},
      abDaysByGroup: {},
      abTimeScheduleByGroup: {}
    }

    this.groupPanelTargets.forEach(panel => {
      const groupKey = panel.dataset.groupKey
      if (!groupKey) return

      const modeSelect = panel.querySelector('[data-ab-config-form-target="modeSelect"]')
      const mode = modeSelect ? modeSelect.value : "automatic"
      config.abModeByGroup[groupKey] = mode

      const dayPanel = panel.querySelector('[data-ab-config-form-target="dayOfWeekPanel"]')
      const timePanel = panel.querySelector('[data-ab-config-form-target="timeOfDayPanel"]')
      if (mode === "dayOfWeek") {
        if (dayPanel) dayPanel.classList.remove("hidden")
        if (timePanel) timePanel.classList.add("hidden")
      } else if (mode === "timeOfDay") {
        if (dayPanel) dayPanel.classList.add("hidden")
        if (timePanel) timePanel.classList.remove("hidden")
      } else {
        if (dayPanel) dayPanel.classList.add("hidden")
        if (timePanel) timePanel.classList.add("hidden")
      }

      const dayCheckboxes = panel.querySelectorAll('[data-ab-config-form-target="dayCheckbox"]')
      const daysByExp = {}
      dayCheckboxes.forEach(cb => {
        const expId = cb.dataset.expId
        const dayIndex = parseInt(cb.dataset.dayIndex, 10)
        if (!daysByExp[expId]) daysByExp[expId] = []
        if (cb.checked) daysByExp[expId].push(dayIndex)
      })
      config.abDaysByGroup[groupKey] = daysByExp

      const timeJsonEl = panel.querySelector('[data-ab-config-form-target="timeScheduleJson"]')
      let schedule = []
      if (timeJsonEl && timeJsonEl.value.trim()) {
        try {
          schedule = JSON.parse(timeJsonEl.value)
        } catch (_e) {}
      }
      config.abTimeScheduleByGroup[groupKey] = Array.isArray(schedule) ? schedule : []
    })

    if (this.hasHiddenInputTarget) {
      this.hiddenInputTarget.value = JSON.stringify(config)
    }
  }

  togglePanels() {
    this.groupPanelTargets.forEach(panel => {
      const modeSelect = panel.querySelector('[data-ab-config-form-target="modeSelect"]')
      const mode = modeSelect ? modeSelect.value : "automatic"
      const dayPanel = panel.querySelector('[data-ab-config-form-target="dayOfWeekPanel"]')
      const timePanel = panel.querySelector('[data-ab-config-form-target="timeOfDayPanel"]')
      if (mode === "dayOfWeek") {
        if (dayPanel) dayPanel.classList.remove("hidden")
        if (timePanel) timePanel.classList.add("hidden")
      } else if (mode === "timeOfDay") {
        if (dayPanel) dayPanel.classList.add("hidden")
        if (timePanel) timePanel.classList.remove("hidden")
      } else {
        if (dayPanel) dayPanel.classList.add("hidden")
        if (timePanel) timePanel.classList.add("hidden")
      }
    })
  }
}
